import ordinal from 'ordinal'

angular
  .module 'filters'
  .filter 'ordinalize', ->
    (data) ->
      ordinal(data)
